import { Action, createReducer, on } from '@ngrx/store';
import { IProductionToolingState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import { addMacRangeSuccessAction, deleteMacRangeSuccessAction, getAuthInfoProductionToolingFailedAction, getAuthInfoProductionToolingSuccessAction, getDeviceProfilesSuccessAction, getDevicesFailedAction, getDevicesSuccessAction, getFirmwareFailedAction, getFirmwareSuccessAction, getMacRangesFailedAction, getMacRangesSuccessAction, setDeviceProfilesSuccessAction } from '../actions/production.actions';

const initialState: IProductionToolingState = {
  permission: null,
  devices: null,
  deviceProfiles: null,
  firmware: null,
  macRanges: null,
};

export const productionReducerImplicit = createReducer(
  initialState,
  on(getAuthInfoProductionToolingSuccessAction, (state, { data: permission }) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoProductionToolingFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
  on(getDevicesSuccessAction, (state, { data: devices }) => ({
    ...state,
    devices,
  })),
  on(getDevicesFailedAction, (state,) => ({
    ...state,
    devices: null,
  })),
  on(getFirmwareSuccessAction, (state, { data: firmware }) => ({
    ...state,
    firmware,
  })),
  on(getFirmwareFailedAction, (state,) => ({
    ...state,
    firmware: null,
  })),
  on(getDeviceProfilesSuccessAction, (state, { data: deviceProfiles }) => ({
    ...state,
    deviceProfiles,
  })),
  on(setDeviceProfilesSuccessAction, (state, { data: deviceProfiles }) => ({
    ...state,
    deviceProfiles,
  })),
  on(getMacRangesSuccessAction, (state, { data: macRanges }) => ({
    ...state,
    macRanges,
  })),
  on(getMacRangesFailedAction, (state,) => ({
    ...state,
    macRanges: null,
  })),
  on(addMacRangeSuccessAction, (state, { data: newRange }) => ({
    ...state,
    macRanges: [...(state.macRanges ?? []), newRange],
  })),
  on(deleteMacRangeSuccessAction, (state, { data: rangeId }) => ({
    ...state,
    macRanges: (state.macRanges ?? []).filter(r => r.id !== rangeId),
  }))
  // Using the old data is fine since we have the ETag
  // on(getDeviceProfilesFailedAction, (state,) => ({
  //   ...state,
  //   deviceProfiles: null,
  // })),
);

export function productionToolingReducer(state: any, action: Action): IProductionToolingState {
  return productionReducerImplicit(state, action);
}
